'use client';

import { createContext, useContext, type ReactNode } from 'react';

type ExternalNetworkGraphNodeActionsContextValue = {
  selectedNodeId?: string | null;
  isExpanding?: boolean;
  onExpand: (nodeId: string) => void;
  onViewDetails: (nodeId: string) => void;
  onCloseSelection: () => void;
};

const ExternalNetworkGraphNodeActionsContext =
  createContext<ExternalNetworkGraphNodeActionsContextValue | null>(null);

export function ExternalNetworkGraphNodeActionsProvider({
  value,
  children,
}: {
  value: ExternalNetworkGraphNodeActionsContextValue;
  children: ReactNode;
}) {
  return (
    <ExternalNetworkGraphNodeActionsContext.Provider value={value}>
      {children}
    </ExternalNetworkGraphNodeActionsContext.Provider>
  );
}

export function useExternalNetworkGraphNodeActions() {
  return useContext(ExternalNetworkGraphNodeActionsContext);
}
